var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Link as MUILink } from '@mui/material';
import { cx } from '@emotion/css';
import React from 'react';
import { useStyles } from './Link.styles';
const DEFAULT_UNDERLINE = 'hover';
export function Link(props) {
    const { children, className, disabled, id, underline = DEFAULT_UNDERLINE, onClick } = props, rest = __rest(props, ["children", "className", "disabled", "id", "underline", "onClick"]);
    const classes = useStyles();
    /**
     * If 'component' prop is passed, we want to pass all props down to the component
     * (also non-standard props, not defined explicitly in LinkProps interface),
     * as the Component in 'component' prop can make use of them.
     */
    if ('component' in rest && rest.component !== undefined) {
        return (React.createElement(MUILink, Object.assign({ className: cx(classes.root, className, { disabled }), id: id, underline: underline, onClick: onClick }, rest), children));
    }
    return (React.createElement(MUILink, { className: cx(classes.root, className, { disabled }), href: props.href, id: id, rel: props.rel, target: props.target, underline: underline, onClick: onClick }, children));
}
//# sourceMappingURL=Link.js.map